import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import NewSagaDM from '../../saga/saga.types';
import { LoyaltyType } from '../customer.types';
import { CustomerLoyalty } from './customer-loyalty.types';
import ACResponse from '../../common/response';

@Injectable()
export class CustomerLoyaltyService {
	private sagaAPIURL = 'saga-api';
	private loyaltyAPIURL = 'loyalty-api';
	private defaultUserId = 145137;

	constructor(private http: HttpClient) { }

	createLoyalty(customerId: number): Promise<string> {
		const newSagaDM: NewSagaDM = {
			service: 'hq',
			event: 'CREATE_LOYALTY',
			// FIXME: Use `Ray` for now
			userId: this.defaultUserId,
			data: {
				customerId: customerId,
				type: LoyaltyType.Free,
				points: 0,
			}
		};

		return this.http.post<ACResponse<string>>(`${this.sagaAPIURL}/api/v1`, newSagaDM).toPromise()
			.then(
				response => {
					return response.data;
				}
			)
			.catch(
				err => {
					console.error('Error creating loyalty for CustomerId:', customElements, 'Error:', err);
					return undefined;
				}
			);
	}

	readAllLoyalties(): Promise<CustomerLoyalty[]> {
		return this.http.get<ACResponse<CustomerLoyalty[]>>(`${this.loyaltyAPIURL}/api/v1`).toPromise()
			.then(
				response => {
					return response.data;
				}
			)
			.catch(
				err => {
					console.error('Error getting loyalties for CustomerId:', customElements, 'Error:', err);
					return undefined;
				}
			);
	}

	readLoyalty(customerId: number): Promise<CustomerLoyalty> {
		return this.http.get<ACResponse<CustomerLoyalty>>(`${this.loyaltyAPIURL}/api/v1/customers/${customerId}`).toPromise()
			.then(
				response => {
					return response.data;
				}
			)
			.catch(
				err => {
					console.error('Error getting loyalty for CustomerId:', customElements, 'Error:', err);
					return undefined;
				}
			);
	}

	updateLoyaltyType(customerId: number, type: LoyaltyType): Promise<string> {
		const newSagaDM: NewSagaDM = {
			service: 'hq',
			event: 'UPDATE_LOYALTY_TYPE',
			// FIXME: Use `Ray` for now
			userId: this.defaultUserId,
			data: {
				customerId: customerId,
				type: type,
			}
		};

		return this.http.post<ACResponse<string>>(`${this.sagaAPIURL}/api/v1`, newSagaDM).toPromise()
			.then(
				response => {
					return response.data;
				}
			)
			.catch(
				err => {
					console.error('Error updating loyalty for CustomerId:', customElements, 'Error:', err);
					return undefined;
				}
			);
	}

	updateLoyaltyPoints(customerId: number, points: number): Promise<string> {
		const newSagaDM: NewSagaDM = {
			service: 'hq',
			event: 'UPDATE_LOYALTY_POINTS',
			// FIXME: Use `Ray` for now
			userId: this.defaultUserId,
			data: {
				customerId: customerId,
				points: points,
			}
		};
		return this.http.post<ACResponse<string>>(`${this.sagaAPIURL}/api/v1`, newSagaDM).toPromise()
			.then(
				response => {
					return response.data;
				}
			)
			.catch(
				err => {
					console.error('Error updating loyalty for CustomerId:', customElements, 'Error:', err);
					return undefined;
				}
			);
	}
}
